import React from "react";

import { RemoveSplash } from "@mnemonic/mui";
import NotFound from "@mnemonic/mui/PageNotFound";
import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";

const PageNotFound = () => (
  <div style={{ marginTop: "64px" }}>
    <RemoveSplash />
    <NotFound contact={ArgusUtils.getMetaInfo().email} />
  </div>
);

export default PageNotFound;
